import API from "../AxiosClient";
import ErrorHelper from "../../helpers/ErrorHelper";
import TokenDAO from "../../DAO/TokenDAO";

export default class UsuarioService {

	static async usuario(usuarioPk) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			const usuarioResponse = await API.get(`/colaborador/${usuarioPk}/`, {
				headers: {
					Authorization: token
				}
			});

			return usuarioResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async usuarioPorEmpresa(empresaPk, usuarioPk) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			const usuarioResponse = await API.get(`/empresa/${empresaPk}/colaborador/${usuarioPk}/`, {
				headers: {
					Authorization: token
				}
			});

			return usuarioResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async usuarios(params = {}) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			const usuarioResponse = await API.get(`/colaborador/`, {
				params,
				headers: {
					Authorization: token
				}
			});

			return usuarioResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async usuariosPorEmpresa(empresaPk, params = {}) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			const usuarioResponse = await API.get(`/empresa/${empresaPk}/colaborador/`, {
				params,
				headers: {
					Authorization: token
				}
			});

			return usuarioResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async usuariosGerenciados(empresaPk, params = {}) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			const usuarioResponse = await API.get(`/empresa/${empresaPk}/colaborador/gerenciados/`, {
				params,
				headers: {
					Authorization: token
				}
			});

			return usuarioResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async usuariosSupervisores(empresaPk, params = {}) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			const usuarioResponse = await API.get(`/empresa/${empresaPk}/colaborador/supervisores/`, {
				params,
				headers: {
					Authorization: token
				}
			});

			return usuarioResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async getUsuarioPorCpf(params = {}) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			const usuariosResponse = await API.get(`/usuario/`, {
				params,
				headers: {
					Authorization: token
				}
			});

			const usuarios = usuariosResponse.data.results;

			if (usuarios.length) {
				return usuarios[0];
			}

			return null;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async criarUsuario(usuario) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			await API.post(`/colaborador/`, usuario, {
				headers: {
					Authorization: token
				}
			});
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async criarUsuarioPorEmpresa(empresaPk, usuario) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			await API.post(`/empresa/${empresaPk}/colaborador/`, usuario, {
				headers: {
					Authorization: token
				}
			});
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async editarUsuario(usuarioPk, usuario) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			await API.put(`/colaborador/${usuarioPk}/`, usuario, {
				headers: {
					Authorization: token
				}
			});
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async editarUsuarioPorEmpresa(empresaPk, usuarioPk, usuario) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			await API.put(`/empresa/${empresaPk}/colaborador/${usuarioPk}/`, usuario, {
				headers: {
					Authorization: token
				}
			});
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async mudarSenha(data) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			const mudarSenhaResponse = await API.post(`/auth/password/`, data, {
				headers: {
					Authorization: token
				}
			});
			return mudarSenhaResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

}
